<template>
  <div class="md-layout main-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :dateRangeMenu="false"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-30 md-medium-size-35 md-small-size-50 md-xsmall-size-100">
              <h5>{{$lang.titles.appliance_properties}}</h5>
              <md-field :class="{ 'md-error': validationFailed }">
                <label>{{$lang.general.name}}</label>
                <md-input v-model="appliance.name" @click="validationFailed = false" maxlength="30" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20 md-medium-size-25 md-small-size-50 md-xsmall-size-100">
              <h5>{{$lang.titles.phase_selection}}</h5>
              <md-radio v-model="selectedPhase" value="L1">L1</md-radio>
              <md-radio v-model="selectedPhase" value="L2">L2</md-radio>
              <md-radio v-model="selectedPhase" value="L3">L3</md-radio>
            </div>
          </div>
          <br />
          <md-button class="md-success" @click="sendToAPI" :disabled="!appliance.data.length">{{$lang.keys.save_profile}}</md-button>

          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import axios from "axios";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";
import areaChartOptions from "@/config/charts/line";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null,
      selectedPhase: "L1",
      appliance: {
        name: "",
        data: []
      },
      validationFailed: false
    };
  },
  computed: {
    WSmessage() {
      return this.$store.getters.getDataMessage;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
  },
  watch: {
    WSmessage: function(payload, oldPayload) {
      if (payload) {
        const { chart } = this.$refs.areaChart;

        // add the point
        chart.series[0].addPoint(
          [payload.ts * 1000, payload.P[this.selectedPhase]],
          false
        );
        chart.series[1].addPoint(
          [payload.ts * 1000, payload.I[this.selectedPhase]],
          false,
          false
        );
        chart.series[2].addPoint(
          [payload.ts * 1000, payload.Q[this.selectedPhase]],
          false,
          false
        );

        chart.redraw();
      } else {
        this.$refs.snackbar.notify(this.$lang.messages.api_communication_error);
      }
    }
  },
  created() {
    const onZoom = event => {
      if (event.xAxis) {
    const { chart } = this.$refs.areaChart;

    const selected_power_P = chart.xAxis[0].series[0].data.filter(el => el.x >= event.xAxis[0].min -1 && el.x <= event.xAxis[0].max);
    const selected_power_I = chart.xAxis[0].series[1].data.filter(el => el.x >= event.xAxis[0].min -1 && el.x <= event.xAxis[0].max);
    const selected_power_Q = chart.xAxis[0].series[2].data.filter(el => el.x >= event.xAxis[0].min -1 && el.x <= event.xAxis[0].max);

    const dataLength = selected_power_P.length;
    
    
    for(let index = 0; index < dataLength; index++) {
      this.appliance.data.push({
        ts: Math.floor(selected_power_P[index].x / 1000),
        P: selected_power_P[index].y,
        I: selected_power_I[index].y,
        Q: selected_power_Q[index].y
      })
    }
      } else {
        this.appliance.data = [];
      }
    };

    this.chartOptions = areaChartOptions;
    //this.chartOptions.title.text = this.$lang.charts.realtime_active_power;
    this.chartOptions.chart = {
        "polar": false,
        "zoomType": "x"
    };
    this.chartOptions.yAxis.labels.format = "{value}";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} {series.options.unit}</b><br/>";
    this.chartOptions.series = [
      {
        name: this.$lang.charts.active_power,
        unit: "W",
        type: "spline",
        data: []
      },
      {
        name: this.$lang.charts.current,
        unit: "A",
        type: "spline",
        data: []
      },
      {
        name: this.$lang.charts.reactive_power,
        unit: "VAr",
        type: "spline",
        data: []
      }
    ];
    this.chartOptions.chart.events = {
      selection: function(event) {
          onZoom(event);
      }
    };
  },

  methods: {
    sendToAPI() {

      if (this.appliance.name.length < 2){
        this.validationFailed = true;
      } else {
          axios({
        //crossDomain: true,
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/nilm/appliance-recording",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          name: this.appliance.name,
          data: this.appliance.data,
          phase: this.selectedPhase,
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            this.$refs.snackbar.notify(
              this.$lang.messages.appliance_imprint_save_success
            );
          } else {
              this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        })
        .catch(error => {
          if (error.response.data.code == 525) {
            this.$refs.snackbar.notify(
              this.$lang.messages.many_edges
            );
          } else if (error.response.data.code == 526) {
            this.$refs.snackbar.notify(
              this.$lang.messages.any_edge
            );
          } else if (error.response.data.code == 527) {
            this.$refs.snackbar.notify(
              this.$lang.messages.duplicate_appliance
            );
          } else if (error.response.data.code == 528) {
            this.$refs.snackbar.notify(
              this.$lang.messages.small_edges
            );
          } else  {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
      }
    }
  },
  beforeDestroy() {
    this.chartOptions = null;
    this.appliance = {
        name: "",
        data: []
    };
  }
};
</script>

<style lang="scss" scoped>
.main-layout {
  margin-top: -29px;
}
</style>